import _ from 'lodash'
import RouteConstants from '../constants/RouteConstants';
import ApplicationConstants from '../constants/ApplicationConstants';
import IDVerificationConstants from '../constants/IDVerificationConstants';
import SelectCustomerConstants from '../constants/SelectCustomerConstants';
import ApplicationActions from '../actions/ApplicationActions';

function navigate(router, to) {
    if (router && typeof router.push === 'function') {
        router.push(to);
        ApplicationActions.onContinueSession();
    }else {
        router.push(RouteConstants.NotFound);
    }
    setTimeout(() => ApplicationActions.transitionCompleted(to), 0);
}

class TransitionsClass {
    
    forwardFromConfirmDetails(router, args) {
        if (args) {
            // shell account overrides all other branches
            // explicity handle shell account navigation
            if (args.isShellAccount) {
                navigate(router, RouteConstants.Declaration);
                return;
            }

            if (_.has(args, 'identificationMode')) {
                switch (args.identificationMode) {
                    case ApplicationConstants.ClientIdentificationModes.ANNUITY_WELCOME:
                        navigate(router, RouteConstants.AnnuitiesWelcomePage);
                        break;
                    case ApplicationConstants.ClientIdentificationModes.PAPER_FORM:
                        navigate(router, RouteConstants.Declaration);
                        break;
                    default:
                        navigate(router, RouteConstants.Declaration);
                        break;
                }
            } else if (_.has(args, 'eligibility') && args.eligibility === IDVerificationConstants.Eligibility.Eligible) {
                navigate(router, RouteConstants.ElectronicSubmission);
            } else if (_.has(args, 'editMode') && args.editMode === true) {
                navigate(router, RouteConstants.ApplicationForm);
            } else {
                navigate(router, RouteConstants.Declaration);
            }
            return;
        }

        navigate(router, RouteConstants.Declaration);
    }

    forwardFromClientSearch(router) {
        navigate(router, RouteConstants.ClientResults);
    }

    forwardfromApplicationForm(router,args) {
        if(args !== undefined && args.identificationMode === ApplicationConstants.ClientIdentificationModes.E_FORM) {
            navigate(router, RouteConstants.IDVerification);
        }
        else {
            navigate(router, RouteConstants.ConfirmDetails);
        }
    }

    forwardFromClientSelect(router, args) {
        if (args.productId) {
            navigate(router, RouteConstants.ApplicationForm);
        }
        else {
            navigate(router, RouteConstants.ClientApplication);
        }
    }

    forwardFromDeclaration(router, args) {
        if (args) {
            if (args.submitFailed) {
                navigate(router, RouteConstants.ApplicationForm);
            } else if (args.isShellAccount) {
                // explicity handle shell account navigation
                navigate(router, RouteConstants.Congratulations); 
            } else if (args.valid) {
                navigate(router, RouteConstants.NetCodeEntry);
            } else {
                navigate(router, RouteConstants.Congratulations); 
            }
            return;
        }
        navigate(router, RouteConstants.Congratulations);
    }

    forwardFromElectronicSubmission(router, args) {
        if (args && args.valid) {
            navigate(router, RouteConstants.Declaration);
        } else if (args && args.submitFailed) {
            navigate(router, RouteConstants.ApplicationForm);
        } else {
            navigate(router, RouteConstants.Congratulations);
        }
    }

    forwardFromNetCodeEntry(router, args) {
        if (args && args.valid) {
            navigate(router, RouteConstants.Congratulations);
        } else if (args && args.submitFailed){
            navigate(router, RouteConstants.ApplicationForm);
        } else {
            navigate(router, RouteConstants.Congratulations);
        }
    }

    /// args.backButton takes precedence
    forwardFromIDVerification(router, args) {
        if (args) {
            // if args.backButton, then it is actually backFromIDVerification(router, [Optional]args)
            if (args.backButton){
                if (args.submitFailed){
                    navigate(router, RouteConstants.ApplicationForm);
                }
                else {
                    navigate(router, RouteConstants.ApplicationForm);
                }
            }
            else if (args.skipToConfirmDetails) {
                navigate(router, RouteConstants.ConfirmDetails);
            } else {
                // (hasAllRequirements && submitDocument) evaluates to True
                if (args.submitDocument) {
                    navigate(router, RouteConstants.ConfirmDetails);
                } else {
                    navigate(router, RouteConstants.ConfirmDetails);
                }

            }

        } else {
            navigate(router, RouteConstants.ConfirmDetails);
        }
    }

    forwardFromSelectProduct(router) {
        navigate(router, RouteConstants.ApplicationForm);
    }

    forwardFromClientType(router, args) {
        const applicationLinkTypes = SelectCustomerConstants.ApplicationLinkTypes;
        if (!args) {
            throw 'Error in forwarding from client type: args can\'t be null or empty';
        }

        switch (args.applicationLinkType) {
            case applicationLinkTypes.EXISTING_LISTED_CLIENT:
                if (args.searchResult === SelectCustomerConstants.SearchResult.FOUND) {
                    navigate(router, RouteConstants.ClientResults);
                } else {
                    navigate(router, RouteConstants.ClientSearch);
                }
                break;

            case applicationLinkTypes.EXISTING_NOT_LISTED_CLIENT:
                navigate(router, RouteConstants.ClientOin);
                break;

            case applicationLinkTypes.NEW_CLIENT:
                if (args.productId) {
                    navigate(router, RouteConstants.ApplicationForm);
                }
                else {
                    navigate(router, RouteConstants.ClientApplication);
                }
                break;

            default:
                navigate(router, RouteConstants.ClientApplication);
                break;
        }
    }

    forwardFromApplicationLoading(history, args) {
        if (!args) {
            throw 'Error in forwarding from application loading: args can\'t be null or empty';
        }

        switch (args.nextView) {
            case ApplicationConstants.ApplicationLoadingViews.APPLICATION_FORM:
                navigate(history, RouteConstants.ApplicationForm);
                break;

            case ApplicationConstants.ApplicationLoadingViews.CLIENT_SELECT:
                navigate(history, RouteConstants.ClientType);
                break;

            default:
                throw 'Error in forwarding from application loading: unknown view';
        }
    }
}

// singleton
const Transitions = new TransitionsClass();

export default Transitions;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./core/Transitions.js